/* eslint-disable jsx-a11y/anchor-is-valid */
/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import AssetImport from "./AssetImport";
import holderImage from "../../../img/property_placeholder.jpg";

export default class LookupResult extends PureComponent {
  static propTypes = {
    asset: PropTypes.object.isRequired
  };

  constructor() {
    super();
    this.state = {
      importModal: false
    };
  }

  toggleImportModal = e => {
    this.setState({
      importModal: !this.state.importModal
    });
  };

  render() {
    const { asset } = this.props;
    return (
      <div
        className="col-sm-12 col-md-6 col-lg-6 col-xl-6"
        onClick={this.toggleImportModal}
      >
        <div className="asset-search-block">
          <div className="asset-search-deatils">
            <div className="asset-listthumb">
              <img
                src={asset.imageUrl}
                alt=""
                onError={e => {
                  e.target.src = holderImage;
                }}
              />
            </div>
            <div>
              <h4>{asset.address}</h4>
              <p>Assessor's parcel number: {asset.apn}</p>
            </div>
          </div>
          <a href="#" className="nextbtns">
            <svg id="Layer_1" viewBox="0 0 224.3 407.44">
              <polygon points="21.25 0 0 21.18 181.95 203.72 0 386.26 21.25 407.44 224.3 203.72 21.25 0" />
            </svg>
          </a>
        </div>
        <AssetImport
          data={asset}
          modalOpen={this.state.importModal}
          toggleModal={this.toggleImportModal}
          toggleMainModal={this.props.toggleMainModal}
        />
      </div>
    );
  }
}
